import api from '../api'
import auth from '../token'

export default {

  getUsers(page = 0, word = '', size = 5) {
    return api.request('GET', '/user/list?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
  },

  getStationByUsername(username) {
    return api.request('GET', '/user/stationByUsername/' + username);
  },

  create(form) {
    return api.request('POST', `/user/create?roles=${form.rol}&stations=`, form);
  },

  delete(id) {
    return api.request('DELETE', '/user/delete/' + id);
  },

  getByID(id) {
    return api.request('GET', '/user/' + id);
  },

  update(id, form) {
    return api.request('PUT', '/user/update/' + id, form);
  },

  getUsersKeycloak() {
    return keycloak.request('GET', '/user/viewUsers');
  },

  checkUserName(username) {
    return api.request('GET', '/user/getByUsername/' + username);
  },

  checkEmail(email) {
    return keycloak.request('GET', '/user/viewUserEmail/' + email);
  },

  createUserKeycloak(form) {
    return keycloak.request('POST', '/user/createUser', form);
  },

  updateUserKeycloak(id, data) {
    return api.request('PUT', `/user/update/${id}?roles=${data.rol}&stations=`, data);
  },

  getUserByIdKeycloak(id) {
    return keycloak.request('GET', '/user/viewUser/' + id);
  },

  getUserByUsernameKeycloak(username) {
    return keycloak.request('GET', '/user/viewUserName/' + username);
  },

  deleteUserKeycloak(id) {
    return keycloak.request('DELETE', '/user/deleteUser/' + id);
  },

  restoreUserPassword(form) {
    return api.request('PUT', '/user/restorePassword', form)
  },

  sendEmailRestore(form) {
    return api.request('PUT', '/user/restorePasswordForEmail', form, 'restore')
  },

  logout() {
    return api.request('POST', '/logout', { refreshToken: localStorage.getItem('refreshToken') })
  }

}
